import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/events/EventCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsDetails"] */ "/app/src/sections/events/events-details/details/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExpandingCard"] */ "/app/src/sections/events/events-details/hero/ExpandingCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroAsset"] */ "/app/src/sections/events/events-details/hero/HeroAsset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/app/src/sections/events/events-details/register/RegisterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeakerCard"] */ "/app/src/sections/events/events-details/speakers/SpeakerCard.tsx");
